
import {Component, Prop, Vue} from "vue-property-decorator";
  import {bus} from "@/plugins/bus";
  import {Barrier} from "@/modules/barriers/interfaces/barrier.interface";

  @Component({})
  export default class ListSettings extends Vue {
    @Prop() value: boolean;
    @Prop() parkId: number;

    hasCustomOrder = false;

    get displayChangeOrder() { return this.value; }
    set displayChangeOrder(value) { this.$emit('input', value); }

    mounted() {
      let storageOrder = localStorage.getItem(Barrier.LocalStorageKeys.ListOrder);
      if (storageOrder) {
        let parsedOrder = JSON.parse(storageOrder);
        this.hasCustomOrder = Boolean(parsedOrder[this.parkId.toString()]);
      }
    }

    changeDisplayOrder(finishChanging = false) {
      if (finishChanging) this.hasCustomOrder = finishChanging;
      this.displayChangeOrder = !this.displayChangeOrder;
      this.$emit('closeDropdown');
    }

    clearCustomOrder() {
      this.displayChangeOrder = false;
      this.hasCustomOrder = false;

      let resultValue = {};
      let storageOrder = localStorage.getItem(Barrier.LocalStorageKeys.ListOrder);
      if (storageOrder) {
        let parsedOrder = JSON.parse(storageOrder);
        resultValue =  Object.assign(resultValue, parsedOrder, { [this.parkId.toString()]: '' });
      }
      localStorage.setItem(Barrier.LocalStorageKeys.ListOrder, JSON.stringify(resultValue));
      bus.$emit(Barrier.BusEvents.ClearListOrdering);

      this.$emit('closeDropdown');
    }

  }
